import React from "react";

import { Box, Button, Hidden } from "@origin-digital/ods-core";

import { IconHelp } from "@origin-digital/ods-icons";
import styled from "styled-components";
import { IconButton } from "./ActionBarMobile";

const ButtonWrapper = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "right",
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: "44px",
  width: "auto",
  marginRight: `-${theme.space.small}px`,

  [theme.breakpoints.up("lg")]: {
    width: "auto",
    marginRight: 0,
  },

  "& button": {
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    width: "auto",
    padding: 0,

    [theme.breakpoints.up("lg")]: {
      width: "auto",
      position: "relative",
      marginRight: `-${theme.space.xsmall}px`,

      "& svg": {
        width: theme.shape.iconSizes.xxsmall,
        height: theme.shape.iconSizes.xxsmall,
      },
    },
  },
}));

const IconContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  position: "relative",
  width: "auto",
  height: "44px",
  alignItems: "center",
  justifyContent: "center",
  marginRight: theme.space.small,
  marginLeft: theme.space.small,

  [theme.breakpoints.up("lg")]: {
    width: "auto",
    marginRight: 0,
    marginLeft: 0,
  },

  "&& .MuiSvgIcon-root": {
    color: theme.palette.neutral.dark,
    fontSize: theme.shape.iconSizes.xsmall,
  },
}));

export const helpSupportButtonMetadata = {
  name: "help",
  title: "Help",
  ariaLabel: "Go to Help and Support page",
};

export const HelpSupportButton = ({ onClick }: { onClick?: () => void }) => {
  const { name, title, ariaLabel } = helpSupportButtonMetadata;

  return (
    <ButtonWrapper>
      <Hidden above="lg">
        <ButtonContainer data-id="mobile-help-support-button">
          <IconButton
            type="button"
            onClick={onClick}
            id={`${name}-button`}
            aria-label={ariaLabel}
          >
            <IconContainer>
              <IconHelp size="xsmall" />
            </IconContainer>
          </IconButton>
        </ButtonContainer>
      </Hidden>
      <Hidden below="lg">
        <ButtonContainer data-id="desktop-help-support-button">
          <Button
            variant="text"
            color="secondaryB"
            size="small"
            onClick={onClick}
            id={`${name}-button`}
            aria-label={ariaLabel}
            icon={<IconHelp size="small" color="neutralDark" />}
          >
            {title}
          </Button>
        </ButtonContainer>
      </Hidden>
    </ButtonWrapper>
  );
};
